var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExternalLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link",
    transform: "translate(10.679 11.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33748",
    "data-name": "Group 33748",
    transform: "translate(-8.679 -9.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40206",
    "data-name": "Path 40206",
    d: "M158.822,280.12h-.931a3.021,3.021,0,0,0-3.114,3.283v5.158a3,3,0,0,0,3.114,3.277h5.491a3.016,3.016,0,0,0,3.113-3.277v-.785",
    transform: "translate(-154.778 -277.769)",
    fill: "none",
    stroke: "#0062ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40283",
    "data-name": "Path 40283",
    d: "M0,0H9.84",
    transform: "translate(11.715 2.353) rotate(135)",
    fill: "none",
    stroke: "#0062ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40284",
    "data-name": "Path 40284",
    d: "M3.34,6.653,0,3.327,3.341,0",
    transform: "translate(14.067 4.704) rotate(135)",
    fill: "none",
    stroke: "#0062ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13905",
    "data-name": "Rectangle 13905",
    width: 18,
    height: 18,
    transform: "translate(-10.679 -11.353)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExternalLink);
export default __webpack_public_path__ + "static/media/IconExternalLink.8cccd94c65784b21b713fac1c40ba949.svg";
export { ForwardRef as ReactComponent };